import React from 'react';
import { motion } from 'framer-motion';

const buckets = {
  'Backend Engineering': ['Laravel', 'PHP', 'MySQL', 'Redis', 'Livewire'],
  'Frontend Development': ['Vue.js', 'Livewire'],
  'Infrastructure & DevOps': ['AWS', 'Docker', 'Git'],
};

const SkillsV2 = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="w-full rounded-2xl bg-gray-50 border border-gray-200 p-6 md:p-8">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 tracking-tight text-gray-900">Skills</h2>
        <div className="w-16 h-1 bg-blue-600 rounded mt-2 mb-6"></div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {Object.entries(buckets).map(([key, values], i) => (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl p-6 md:p-8 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3">{key}</h3>
              <div className="flex flex-wrap gap-2 mt-4">
                {values.map((v) => (
                  <span key={v} className="bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-full text-sm text-gray-700 transition-colors duration-200">
                    {v}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};

export default SkillsV2;
